<script lang="ts">
  interface Props {
    size?: number;
    class?: string;
  }
  let { size = 16, class: cls = '' }: Props = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.75"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={cls}
  aria-hidden="true"
>
  <path d="M4 7h16" />
  <path d="M4 12h16" />
  <path d="M4 17h16" />
</svg>
